export const formatToMoney = (value, decimals = 2) => {
  // Handle invalid values
  const numValue = Number(value);
  if (isNaN(numValue)) {
    return '0,00';
  }

  // Prevent "-0,00": if the value rounds to zero, treat as positive zero
  const rounded = parseFloat(numValue.toFixed(decimals));
  const displayValue = rounded === 0 ? 0 : numValue;

  const formattedValue = displayValue.toFixed(decimals).replace('.', ',');

  const stringValue = formattedValue.split(',');
  const formattedString = `${Number(stringValue[0]).toLocaleString('pt-BR')},${stringValue[1]}`;
  return formattedString;
};

export const formatToMoneyWithSymbol = (value) => {
  return `R$ ${formatToMoney(value)}`;
};

export const formatWithLimitedDecimals = (value, decimals = 2) => {
  return Number(value).toFixed(decimals);
};
